import api from '@/api';

import { API_BASE_URL } from '..';

import { ListCashMovementQuery } from './BoxMovement.types';
import { CashMovement } from '@/core/domain/financial/BoxMovement/BoxMovement.types';

const baseUrl = `${API_BASE_URL}/BoxMovement`;

export async function listCashMovement(params?: ListCashMovementQuery) {
  const result = (await api.get(baseUrl, params)) as unknown;

  return result as CashMovement;
}
